/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const MAX_DISPLAY_NAME_LENGTH = 500;
export const MAX_DESCRIPTION_LENGTH = 1000;
